module.exports = __webpack_public_path__ + "img/petal_2.8ea0c153.png";